import { atomFamily } from "recoil";

export type MasterDataKey = "interestedPropertyTypes" | "agentSearchTags";
export type MasterDataStatus = "idle" | "loading" | "ready" | "error";

// 成功した空配列と未取得・失敗を区別する。永続化せず、サインアウト時にリセットする。
export const masterDataStatusState = atomFamily<MasterDataStatus, MasterDataKey>({
  key: "masterDataStatusState",
  default: "idle",
});
